import * as React from 'react';
function IconTick(props) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconTick", ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.025 14.718l-4.95-4.95-1.414 1.414 6.364 6.364L21.34 6.232l-1.414-1.414-9.9 9.9z", fill: "currentColor" })));
}
export default IconTick;
//# sourceMappingURL=IconTick.js.map